import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang, postPath } from "../i18n";
import SiteImage from "./SiteImage";
import { CATEGORIES } from "../data/posts";

const fmt = (iso, lang) =>
  new Date(iso + "T12:00:00").toLocaleDateString(lang === "es" ? "es-US" : "en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

const BlogCard = ({ post, large = false }) => {
  const { lang, t } = useLang();
  const c = post[lang] || post.en;
  const cat = CATEGORIES[post.category]?.[lang] || post.category;

  return (
    <Link
      to={postPath(lang, post.slug)}
      data-testid={`blog-card-${post.slug}`}
      onClick={() => window.scrollTo(0, 0)}
      className="group block border border-[#171717]/12 bg-[#F4F0E8] transition-all duration-300 hover:-translate-y-1.5 hover:border-[#C6A46A]/60"
    >
      <SiteImage
        slot={post.img}
        alt={c.title}
        className={`overflow-hidden ${large ? "aspect-[16/8]" : "aspect-[16/9]"}`}
        imgClassName="h-full w-full object-cover grayscale-[35%] transition-transform duration-700 group-hover:scale-105"
      />
      <div className={large ? "p-8 sm:p-10" : "p-6 sm:p-8"}>
        <div className="flex items-center gap-3">
          <span className="eyebrow text-[#8a6f3e]">{cat}</span>
          {post.status !== "published" && (
            <span className="border border-[#C6A46A]/50 px-2 py-0.5 text-[0.55rem] uppercase tracking-[0.15em] text-[#8a6f3e]">
              {t.common.draft}
            </span>
          )}
        </div>
        <h3 className={`mt-4 font-light leading-snug tracking-tight text-[#171717] ${large ? "text-2xl sm:text-3xl" : "text-lg sm:text-xl"}`}>
          {c.title}
        </h3>
        <p className="mt-3 text-sm leading-relaxed text-[#171717]/65">{c.excerpt}</p>
        <div className="mt-6 flex items-center justify-between border-t border-[#171717]/10 pt-4 text-xs text-[#171717]/50">
          <span>
            {fmt(post.date, lang)} · {post.reading} {t.common.minRead}
          </span>
          <ArrowUpRight className="h-4 w-4 text-[#C6A46A] transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
